import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { database } from '../../Firebase';
import { ref, onValue, push, set, remove } from 'firebase/database';

const SangynaAaniSanket = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // eslint-disable-next-line no-unused-vars
    const { grampanchayatName } = location.state || {}; // Assuming passed state

    const [selectedType, setSelectedType] = useState('Business');
    const [isAddingNew, setIsAddingNew] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [items, setItems] = useState([]);
    const [editId, setEditId] = useState(null);

    // Fetch data from Firebase based on selectedType
    useEffect(() => {
        const itemsRef = ref(database, `MasterData/Definitions/${selectedType}`);
        const unsubscribe = onValue(itemsRef, (snapshot) => {
            const data = snapshot.val();
            const loadedItems = [];
            if (data) {
                for (let key in data) {
                    loadedItems.push({ id: key, ...data[key] });
                }
            }
            setItems(loadedItems);
        });

        return () => unsubscribe();
    }, [selectedType]);

    const handleSave = () => {
        if (!inputValue.trim()) return;

        const itemsRef = ref(database, `MasterData/Definitions/${selectedType}`);
        
        if (editId) {
             // Update existing
             const itemRef = ref(database, `MasterData/Definitions/${selectedType}/${editId}`);
             set(itemRef, { name: inputValue });
             setEditId(null);
        } else {
            // Add new
            const newRef = push(itemsRef);
            set(newRef, { name: inputValue });
        }

        setInputValue('');
        setIsAddingNew(false);
    };

    const handleEdit = (item) => {
        setInputValue(item.name);
        setEditId(item.id);
        setIsAddingNew(true);
    };
    
    // eslint-disable-next-line no-unused-vars
    const handleDelete = (id) => {
        if(window.confirm('Are you sure you want to delete this item?')) {
            const itemRef = ref(database, `MasterData/Definitions/${selectedType}/${id}`);
            remove(itemRef);
        }
    }

    const handleCancel = () => {
        setIsAddingNew(false);
        setInputValue('');
        setEditId(null);
    };

    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
            {/* Header */}
            <div className="bg-[#267c77] text-white p-4 flex items-center gap-4 shadow-md">
                <button onClick={() => navigate(-1)} className="hover:bg-white/20 p-2 rounded-full transition-colors">
                    <FiArrowLeft className="w-6 h-6" />
                </button>
                <h1 className="text-xl font-bold">संज्ञा आणि संकेत</h1>
            </div>

            <div className="max-w-4xl mx-auto p-4 md:p-8">
                <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-[#267c77]/30">
                    <div className="bg-[#267c77] text-white p-4">
                        <h2 className="text-lg font-semibold">संज्ञा आणि संकेत</h2>
                    </div>

                    <div className="p-6">
                        {/* Control Row */}
                        <div className="flex flex-wrap items-center gap-4 mb-6">
                            <label className="text-gray-700 font-medium">प्रकाराचे नाव</label>
                            <div className="relative flex-1 max-w-md">
                                <select 
                                    className="w-full border border-gray-300 rounded px-3 py-2 text-gray-700 bg-white focus:outline-none focus:border-[#267c77]"
                                    value={selectedType}
                                    onChange={(e) => setSelectedType(e.target.value)}
                                >
                                    <option value="Business">Business</option>
                                    <option value="Occupation">Occupation</option>
                                    <option value="Caste">Caste</option>
                                </select>
                            </div>
                            <button 
                                onClick={() => { setIsAddingNew(true); setEditId(null); setInputValue(''); }}
                                className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-6 py-2 rounded font-medium transition-colors"
                            >
                                नविन
                            </button>
                        </div>

                        {/* Existing Table View */}
                        {!isAddingNew && (
                            <div className="overflow-hidden border rounded-lg border-gray-200">
                                <table className="w-full text-left border-collapse">
                                    <thead>
                                        <tr className="bg-[#267c77] text-white">
                                            <th className="p-3 border-r border-white/30 w-20">नंबर</th>
                                            <th className="p-3 border-r border-white/30 text-center">प्रकार</th>
                                            <th className="p-3 w-32 text-center">पर्याय</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={item.id} className="border-b border-gray-200 hover:bg-gray-50">
                                                <td className="p-3 border-r border-gray-200">{index + 1}</td>
                                                <td className="p-3 border-r border-gray-200">{item.name}</td>
                                                <td className="p-3 text-center">
                                                    <button 
                                                        onClick={() => handleEdit(item)}
                                                        className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-4 py-1 rounded text-sm transition-colors"
                                                    >
                                                        बदल
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        {items.length === 0 && (
                                            <tr>
                                                <td colSpan="3" className="p-4 text-center text-gray-500">
                                                    माहिती उपलब्ध नाही.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Add/Edit Form View */}
                        {isAddingNew && (
                            <div className="border border-[#267c77]/30 rounded-lg p-6 bg-white animate-fade-in-down">
                                <div className="flex flex-wrap items-center gap-4 mb-8">
                                    <label className="text-gray-700 font-medium w-32">वार्डचे इंग्रजी नाव</label> {/* Label from image */}
                                    <input 
                                        type="text" 
                                        value={inputValue}
                                        onChange={(e) => setInputValue(e.target.value)}
                                        placeholder="माहिती भरा."
                                        className="flex-1 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                                    />
                                </div>
                                <div className="flex justify-center gap-4 border-t border-gray-100 pt-4 bg-gray-50 -mx-6 -mb-6 p-4">
                                    <button 
                                        onClick={handleSave}
                                        className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-8 py-2 rounded font-medium transition-colors"
                                    >
                                        साठविणे
                                    </button>
                                    <button 
                                        onClick={handleCancel}
                                        className="bg-red-500 hover:bg-red-600 text-white px-8 py-2 rounded font-medium transition-colors"
                                    >
                                        रद्द करणे
                                    </button>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SangynaAaniSanket;
